import * as yup from "yup";
export interface ICandidateForm {
  name: string;
  gender: number;
  email: string;
  phone: string;
  confirm_email: string;
  current_Location: string;
  work_Mode: number;
  hiring_Category: number;
  experience: boolean;
  experience_In_Months: number | null;
  current_Salary: number | null;
  expected_Salary: number | null;
  notice_Period: number | null;
}

export interface IWorkModeDropdown {
  id: number,
  work_Mood: string
}
export const emptyCandidateForm: ICandidateForm = {
  name: "",
  gender: 0,
  email: "",
  confirm_email: "",
  phone: "",
  current_Location: "",
  work_Mode: 0,
  hiring_Category: 0,
  experience: false,
  experience_In_Months: null,
  current_Salary: null,
  expected_Salary: null,
  notice_Period: null,
};


export const candidateSchema = yup.object().shape({
  name: yup
    .string()
    .required("Full name is required")
    .matches(/^[A-Za-z ]+$/, "Full name must contain only letters"),
  gender: yup.number().required("Gender is required ").min(1, "Gender is required").typeError("Gender is required"),
  email: yup.string().email("Invalid email format").required("Email is required"),
  confirm_email: yup.string().required("Please re-enter email").oneOf([yup.ref("email")], "Email does not match"),
  phone: yup.string().required("Phone number is required").matches(/^(\+91\s?)?[6-9]\d{4}\s?\d{5}$/, "Enter a valid Indian phone number"),
  current_Location: yup.string().required("Current location is required"),
  work_Mode: yup.number().required("Work mood is required").min(1, "Work mood is required"),
  hiring_Category: yup.number().required("Hiring category is required").min(1, "Hiring category is required"),
  experience: yup.boolean().typeError("Experience must be a boolean").required("Experience is required"),
  experience_In_Months: yup
    .number()
    .nullable()
    .integer("Experience in months must be a whole number")
    .typeError("Experience in months must be a number")
    .when("experience", {
      is: true,
      then: (schema) =>
        schema
          .required("Experience in months is required")
          .min(0, "Experience in months cannot be negative")
          .max(999, "Experience in months cannot exceed 3 digits"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),


  current_Salary: yup.number().nullable().when("experience", {
    is: true,
    then: (schema) => schema.required("Current Salary is required").min(0, "Salary cannot be negative").typeError("Current Salary must be a number"),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),

  expected_Salary: yup.number().nullable().when("experience", {
    is: true,
    then: (schema) => schema.required("Expected Salary is required").min(0, "Expected Salary cannot be negative").typeError("Expected Salary must be a number"),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),

  notice_Period: yup
    .number()
    .nullable()
    .integer("Notice period must be a whole number")
    .typeError("Notice period must be a number")
    .when("experience", {
      is: true,
      then: (schema) =>
        schema
          .required("Notice period is required")
          .max(999, "Notice period cannot exceed 3 digits"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),

});

export const Header = ["S. No", "Candidate Name", "Job Role", "Experience (in Months)", "Interview Date", "Interview Time", "Interviewer", "Status", "Posted By", "Action"];

export const experince = [
  { label: "Yes", value: true },
  { label: "No", value: false },
]


export interface IEditCandidateDetails {
  candidate_Mast_Id?: number;
  gender: number;
  candidate_Name: string;
  email: string;
  phone: string;
  current_Location: string;
  experience: boolean;
  experience_In_Months: number | null;
  current_Salary: number | null;
  expected_Salary: number | null;
}


export const EditCandidateSchema = yup.object().shape({
  candidate_Name: yup.string().required("Full name is required").matches(/^[A-Za-z ]+$/, "Full name must contain only letters"),
  gender: yup.number().required("Gender is required").min(1, "Gender is required").typeError("Gender is required"),
  email: yup.string().email("Invalid email format").required("Email is required"),
  phone: yup.string().required("Phone number is required").matches(/^(\+91\s?)?[6-9]\d{4}\s?\d{5}$/, "Enter a valid Indian phone number"),
  current_Location: yup.string().required("Current location is required"),
  experience: yup.boolean().typeError("Experience must be a boolean").required("Experience is required"),
  experience_In_Months: yup.number().nullable().integer("Experience in months must be a whole number").typeError("Experience in months must be a number").when("experience", {
    is: true,
    then: (schema) =>
      schema
        .required("Experience in months is required")
        .min(1, "Experience in months cannot be zero")
        .max(999, "Experience in months cannot exceed 3 digits"),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  current_Salary: yup.number().nullable().when("experience", {
    is: true,
    then: (schema) => schema.required("Current Salary is required").min(0, "Salary cannot be negative").typeError("Current Salary must be a number"),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  expected_Salary: yup.number().nullable().when("experience", {
    is: true,
    then: (schema) => schema.required("Expected Salary is required").min(0, "Expected Salary cannot be negative").typeError("Expected Salary must be a number"),

    otherwise: (schema) => schema.notRequired().nullable(),
  }),
});


export const hiringCategoryList = [
  { id: 1, category: "Sourcing" },
  { id: 2, category: "Campus" },
  { id: 3, category: "Walk-in " },

]